export const getLocalDate = (date: string): Date => {
  const timezoneDiff = new Date(date).getTimezoneOffset() * 60000
  return new Date(new Date(date).getTime() + timezoneDiff)
}
